<div class="page-team-container">
  <div class="header-container">
    <div class="wrapper">
      <div class="header">
        Team
      </div>

      <app-button customClasses="px-4"
                  class="invite"
                  text="Invite Teammate"
                  (clicked)="openInviteDialog()"
      ></app-button>
    </div>

    <app-alert [show]="showMessage"
               [type]="alertMessage?.type"
               [message]="alertMessage?.text"
               (closeAlert)="showMessage = false"
               [autohide]="autohideDelay"
    ></app-alert>
  </div>

  <div *ngIf="(loading$ | async) !== true && !(teamList$ | async)?.length" class="empty-status-container">
    <div class="icon-wrapper">
      <img class="users-icon" src="assets/icons/icon-users-active.svg" alt="users-icon"/>
    </div>

    <div class="header">
      Teammates
    </div>

    <div class="sub-header">
      Team members will show up here after they have been invited.
    </div>
  </div>

  <div *ngIf="(teamList$ | async)?.length" class="table-scroll-wrapper">
    <table class="table-primary team-table">
      <thead>
      <tr>
        <th (click)="sortColumn('userName')" class="text-left sort user" scope="col">
          User
          <img [class.asc]="tableColumns.userName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th (click)="sortColumn('role')" class="text-left sort role" scope="col">
          Role
          <img [class.asc]="tableColumns.role" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th (click)="sortColumn('email')" class="text-left sort email" scope="col">
          Email
          <img [class.asc]="tableColumns.email" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th (click)="sortColumn('createDate')" class="text-left sort created" scope="col">
          Created
          <img [class.asc]="tableColumns.createDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg"
               alt="asc"/>
        </th>
            <th (click)="sortColumn('status')" class="text-left sort status" scope="col">
          Status
          <img [class.asc]="tableColumns.status" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="desc"/>
        </th>
<!--        <th (click)="sortColumn('recordsCount')" class="text-right sort records" scope="col">-->
<!--          Records-->
<!--          <img [class.asc]="tableColumns.recordsCount" class="sort-icon" src="assets/icons/icon-arrow-down.svg"-->
<!--               alt="asc"/>-->
<!--        </th>-->
        <th class="text-right controls" scope="col">
          <!-- Controls -->&nbsp;
        </th>
      </tr>
      </thead>
      <tbody>
      <tr class="table-row" *ngFor="let rowData of (teamList$ | async); let i = index">
        <td class="text-left user">
          {{rowData.userName}}
        </td>
        <td class="text-left role">
          <app-badge *ngIf="rowData.role === UserRolesEnum.CompanyAdmin" [color]="BadgeColorsEnum.Default">
            Company Admin
          </app-badge>
          <app-badge *ngIf="rowData.role === UserRolesEnum.PharmacyAdmin" [color]="BadgeColorsEnum.Default">
            Pharmacy Admin
          </app-badge>
          <app-badge *ngIf="rowData.role === UserRolesEnum.PharmacyStaff" [color]="BadgeColorsEnum.Default">
            Staff
          </app-badge>
        </td>
        <td class="text-left email">
          {{rowData.email}}
        </td>
        <td class="text-left created">
          {{rowData.createDate | formattedDate: 'MM d a, yyyy'}}
        </td>
        <td class="text-left status">
          <app-badge *ngIf="rowData.status === UserStatusEnum.InvitePending" [color]="BadgeColorsEnum.Gray">
            Invite Pending
          </app-badge>
          <app-badge *ngIf="rowData.status === UserStatusEnum.Active" [color]="BadgeColorsEnum.Green">
            Active
          </app-badge>
          <app-badge *ngIf="rowData.status === UserStatusEnum.Suspended" [color]="BadgeColorsEnum.Red">
            Suspended
          </app-badge>
        </td>
<!--        <td class="text-right records">-->
<!--          <ng-container *ngIf="rowData.records > 0">-->
<!--            {{rowData.records}}-->
<!--          </ng-container>-->
<!--          <ng-container *ngIf="!rowData.records">-->
<!--            —-->
<!--          </ng-container>-->
<!--        </td>-->
        <td class="text-right controls">
          <ng-container *ngIf="rowData.status === UserStatusEnum.InvitePending">
            <app-button *ngIf="showResend[i]"
                        customClasses="px-4 ml-3"
                        [minWidth]="0"
                        class="resend"
                        styleClass="settings"
                        subStyle="blue"
                        [text]="inviteResent ? 'Invite resent!' : 'Resend'"
                        (clicked)="resend(rowData.email)"
                        [disabled]="inviteResent"
            ></app-button>
            <app-button *ngIf="showResend[i]"
                        customClasses="px-4"
                        [minWidth]="0"
                        class="revoke-invite"
                        subStyle="white"
                        text="Revoke Invite"
                        (clicked)="openRevokeDialog(rowData)"
            ></app-button>
          </ng-container>
          <ng-container *ngIf="rowData.status !== UserStatusEnum.InvitePending
          && +(currentPharmacy$ | async)?.role <= +rowData.role
           && !isProfileOwner(rowData.email)">
            <app-button customClasses="px-4"
                        [minWidth]="0"
                        class="edit"
                        subStyle="white"
                        text="Edit"
                        (clicked)="openEditDialog(rowData)"
            ></app-button>
          </ng-container>
          <ng-container *ngIf="isDevMode && +(currentPharmacy$ | async)?.role === 0">
            isDevMode: {{isDevMode}}, role: {{+(currentPharmacy$ | async)?.role}}, mine: {{isProfileOwner(rowData.email)}}
           <app-button *ngIf="!isProfileOwner(rowData.email)"
                       styleClass="settings"
                       subStyle="red"
                       customClasses="px-4 mr-2 text-center"
                       text="Delete"
                       class="cancel"
                       (clicked)="openDeleteDialog(rowData)"
            >
            </app-button>
          </ng-container>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th>{{(teamList$ | async)?.length}} User{{(teamList$ | async)?.length !== 1 ? 's' : ''}}</th>
      </tr>
      </tfoot>
    </table>
  </div>
</div>

<app-invite-teammates-dialog [show]="showInviteDialog"
                             (closeDialog)="closeInviteDialog()"
                             (afterSave)="afterInvite()"
></app-invite-teammates-dialog>

<app-edit-user-dialog *ngIf="showEditUserDialog"
                      [show]="showEditUserDialog"
                      [user]="chosenUser"
                      (closeDialog)="closeEditDialog()"
                      (afterSaved)="afterSaved($event)"
></app-edit-user-dialog>

<app-warning-dialog [show]="showRevokeDialog"
                    header="Are you sure you want to revoke this invite?"
                    description="A revoked invite will prevent the user from creating an account. The user can be invited again later."
                    acceptBtnText="Yes, revoke invite"
                    (cancel)="closeRevokeDialog()"
                    (next)="revoke()"
></app-warning-dialog>

<app-warning-dialog [show]="showDeleteDialog"
                    header="Are you sure you want to delete this user?"
                    description="A deleted user will not be able to login. The user can be invited again later."
                    acceptBtnText="Yes, delete user"
                    (cancel)="closeDeleteDialog()"
                    (next)="delete()"
></app-warning-dialog>
